<template>
  <div class="bg-container page">
    <div class="dong_box">
      <div class="dong_i"></div>
    </div>

    <div class="bg-wrapper">
      <div class="register">
        <van-nav-bar class="nav-bar">
          <template #left>
            <div style="display:flex;align-items:center;" @click="back()">
              <img src="/img/newLogin/download.png" style="width:20px;height:15px;" />
              <span style="font-size:16px;color:#f3c7a2;margin-left:10px;">返回</span>
            </div>
          </template>
        </van-nav-bar>

        <div class="wrapper">
          <div class="title">{{ $t("auth.register") }}</div>

          <div class="loginForm">
            <!-- ✅ 賬號：加 input-center 讓文字真正置中 -->
            <van-field
              v-model="username"
              clearable
              input-align="center"
              class="input input-center"
              :placeholder="$t('auth.username_place')"
            />
            <div class="sm_tit">
              {{ $t("q2") }}
            </div>

            <!-- ✅ 密碼：加 input-center + 眼睛 icon 不影響置中 -->
            <van-field
              v-model="password"
              :type="passwordType"
              input-align="center"
              class="input input-center"
              :placeholder="$t('auth.pwd_place')"
            >
              <template slot="right-icon">
                <van-icon
                  :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
                  @click="switchPasswordType"
                />
              </template>
            </van-field>

            <div class="sm_tit">
              {{ $t("q3") }}
            </div>

            <!-- 驗證碼（保持原邏輯） -->
            <div class="yam_box">
              <van-field
                v-model="yzm"
                input-align="center"
                class="input"
                placeholder="請輸入右側驗證碼"
              />
              <div class="ym_x">
                <Captcha ref="Captcha" />
              </div>
            </div>

            <div class="sm_tit">
              請輸入右側圖片中的驗證碼（不分大小寫）
            </div>

            <!-- 邀請碼（保持原邏輯） -->
            <van-field
              v-model="code"
              clearable
              input-align="center"
              class="input"
              :placeholder="$t('auth.invite_code_place')"
            />

            <div class="sm_tit">
              {{ $t("q4") }}
            </div>

            <!-- 同意條款（保持原邏輯） -->
            <div class="agreement">
              <van-checkbox v-model="checked" />
              <span class="agreement-text">本人已年滿 18 歲，並同意《註冊條款》。</span>
            </div>

            <van-button class="login-btn" type="primary" size="normal" @click="doRegister()">
              {{ $t("auth.register") }}
            </van-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Captcha from "./Captcha.vue";

export default {
  model: {
    prop: "inputValue",
    event: "input",
  },
  components: {
    Captcha,
  },
  props: {
    inputValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      yzm: "",
      checked: true,
      username: "",
      code: "",
      lang: "zh_tw", // 後端若只認 zh，就改成 "zh"
      password: this.inputValue,
      passwordType: "password",
    };
  },
  created() {
    if (localStorage.getItem("token")) {
      return window.history.back();
    }

    // 保持你原本邏輯
    localStorage.setItem("lang", "zh");
    if (this.$i18n) this.$i18n.locale = "zh";
  },
  methods: {
    switchPasswordType() {
      this.passwordType = this.passwordType === "password" ? "text" : "password";
    },
    back() {
      return window.history.back();
    },

    // ✅ 把任何 msg 都轉成字串，避免 a.replace is not a function
    toToastText(v, fallback) {
      if (fallback === undefined) fallback = "";
      if (v === null || v === undefined || v === "") return String(fallback || "");
      if (typeof v === "string") return v;
      if (typeof v === "number" || typeof v === "boolean") return String(v);
      try {
        return JSON.stringify(v);
      } catch (e) {
        return String(fallback || "");
      }
    },

    doRegister() {
      if (!this.username) {
        this.$toast.fail(this.$t("auth.username_place"));
        return false;
      }
      if (!this.password) {
        this.$toast.fail(this.$t("auth.pwd_place"));
        return false;
      }

      // 驗證碼校驗（不分大小寫）
      var cc = this.$refs.Captcha.getYam();
      if (
        String(cc || "").trim().toLowerCase() !==
        String(this.yzm || "").trim().toLowerCase()
      ) {
        this.$toast.fail("驗證碼錯誤，請重新輸入");
        return false;
      }

      if (!this.code) {
        this.$toast.fail(this.$t("auth.invite_code_place"));
        return false;
      }

      if (!this.checked) {
        this.$toast.fail("請先勾選同意《註冊條款》");
        return false;
      }

      this.$http({
        method: "post",
        data: {
          username: this.username,
          password: this.password,
          code: this.code,
          lang: this.lang,
        },
        url: "member_register",
      })
        .then((res) => {
          // ✅ 兼容：res 可能是 {code,msg,data} 或 axios {data:{code,msg,data}}
          var r = res;
          if (
            res &&
            typeof res === "object" &&
            res.data &&
            typeof res.data === "object" &&
            (res.data.code !== undefined ||
              res.data.status !== undefined ||
              res.data.msg !== undefined ||
              res.data.info !== undefined ||
              res.data.message !== undefined)
          ) {
            r = res.data;
          }

          var ok = Number(r && r.code) === 200 || Number(r && r.status) === 1;
          var rawMsg = r ? (r.msg || r.info || r.message) : "";
          var msg = this.toToastText(rawMsg, ok ? "註冊成功" : "註冊失敗");

          if (ok) {
            this.$toast.success(msg);

            // token 兼容：data 可能是 token 字串 或物件
            var token = "";
            if (r && r.data !== undefined && r.data !== null) {
              if (typeof r.data === "string") token = r.data;
              else if (typeof r.data === "object") {
                token = r.data.token || r.data.access_token || r.data.jwt || "";
              }
            }
            if (token) localStorage.setItem("token", token);

            this.$router.push("Mine");
          } else {
            this.$toast.fail(msg);
          }
        })
        .catch(() => {
          this.$toast.fail("網路錯誤，請稍後再試");
        });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

.yam_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .ym_x {
    margin-left: 20px;
    padding-top: 40px;
  }
}

.sm_tit {
  font-size: 20px;
  color: #c5c5c5;
  padding-left: 36px;
  margin: 10px 0 20px;
}

.dong_box {
  height: 100%;
  @keyframes bg-data-v-8175861c {
    0%,
    100% {
      background-position-x: 0;
    }
    50% {
      background-position-x: 100%;
    }
  }
  .dong_i {
    height: 100%;
    width: auto;
    animation: bg-data-v-8175861c 20s linear infinite;
    background: url(/img/newLogin/login.jpg) no-repeat 0 0;
    background-size: auto 100%;
  }
}

.register {
  height: 100%;
}

.bg-container .bg-wrapper .register .nav-bar {
  background: 0 0;
}

.bg-container .bg-wrapper {
  background: #00000082 no-repeat 0 0;
  background-size: 100% 100%;
}

.register .wrapper {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.register .wrapper .title {
  line-height: 100px;
  text-align: center;
  font-size: 45px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 5px;
}

.register .wrapper .loginForm {
  padding: 60px;
}

.register .wrapper .loginForm .input {
  padding: 26px 20px;
  margin-top: 40px;
  border-radius: 10px;
  text-align: center;
  font-size: 30px;
  width: 100% !important;
  height: 100%;
  box-sizing: border-box;
  background: linear-gradient(120deg, #212121, #313131);
  border: 2px solid #766350;
  color: #e6b98a;
}

::v-deep .van-cell::after {
  display: none;
}

::v-deep .van-field__right-icon .van-icon,
::v-deep .van-icon {
  font-size: 50px;
}

::v-deep .van-field__control {
  color: #e6b98a;
}

/* ✅ 2) 只針對「賬號/密碼」：視覺真正置中（包含右側 icon/清除 icon 不歪） */
::v-deep .input-center .van-field__body {
  position: relative;
}

::v-deep .input-center .van-field__control {
  width: 100%;
  text-align: center !important;
  /* 左右對稱留白，避免右側 icon 影響居中 */
  padding-left: 70px !important;
  padding-right: 70px !important;
  box-sizing: border-box;
}

/* 右側眼睛 icon */
::v-deep .input-center .van-field__right-icon {
  position: absolute;
  right: 18px;
  top: 50%;
  transform: translateY(-50%);
}

/* clearable 的 X */
::v-deep .input-center .van-field__clear {
  position: absolute;
  right: 18px;
  top: 50%;
  transform: translateY(-50%);
}

.register .wrapper .loginForm .login-btn {
  margin-top: 85px;
  width: 100%;
  height: 80px;
  border-radius: 50px;
  color: #68302c;
  background: linear-gradient(#fde3ca, #e7b486);
  font-size: 30px;
  font-weight: bolder;
  border: none;
}

.register .wrapper .loginForm .agreement {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.register .wrapper .loginForm .agreement .agreement-text {
  margin-left: 10px;
  font-size: 25px;
  color: #fff;
  font-weight: 500;
  line-height: 30px;
}

::v-deep .agreement .van-icon {
  font-size: 30px;
}

::v-deep .agreement .van-checkbox__icon {
  font-size: 38px;
}

::v-deep .agreement .van-checkbox__icon--checked .van-icon {
  color: #fff;
  border-color: rgb(126, 86, 120);
  background-color: rgb(126, 86, 120);
}
</style>
